module.exports = "../../app/cells/components/subproduct_landings/content_cell.rb";